module.exports = __webpack_public_path__ + "img/points_page.0e798de5.jpg";